<template>
  <div class="ui-box-title" @dblclick.stop="updateShow">
    <div class="title-name">{{name}}</div>
    <div v-if="printShow" class="ui-button" @click.stop="print">打印</div>
    <div class="show-box" @click.stop="updateShow">
      <div class="title-name marginRight10">{{show?'收起':'展开'}}</div>
      <i :class="show?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'titleComponents',
  props: {
    name: String,
    show: Boolean,
    printShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tbGoodsSort: ''
    }
  },
  created () {

  },
  methods: {
    print () {
      this.$emit('onPrint')
    },
    updateShow () {
      this.$emit('update:show', !this.show)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-box-title {
  position: relative;
  width: 100%;
  height: 60px;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ui-button {
    position: absolute;
    right: 150px;
    width: 60px;
    height: 27px;
    background: #3d7fff;
    border-radius: 2px;
    font-weight: 400;
    font-size: 11px;
    color: #ffffff;
    line-height: 27px;
    text-align: center;
    cursor: pointer;
  }
  .title-name {
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
    &.marginRight10 {
      margin-right: 10px;
    }
  }
  .show-box {
    display: flex;
    align-items: center;
  }
}
</style>
     